/**
 * Formats a byte count as a human-readable size string (e.g. `1.2 MB`, `340 KB`, `0 B`).
 * Uses binary units (1024). Pure and React-free. Returns `—` for non-finite/negative input.
 */
export function formatFileSize(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return '—';
  if (bytes === 0) return '0 B';

  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / Math.pow(1024, exponent);
  // Whole numbers show no decimals; fractional sizes show one.
  const rounded = value >= 10 || Number.isInteger(value) ? Math.round(value) : Math.round(value * 10) / 10;
  return `${rounded} ${units[exponent]}`;
}
